import { render, staticRenderFns } from "./BrandNameTag.vue?vue&type=template&id=48f429f8"
import script from "./BrandNameTag.vue?vue&type=script&lang=js"
export * from "./BrandNameTag.vue?vue&type=script&lang=js"
import style0 from "./BrandNameTag.vue?vue&type=style&index=0&id=48f429f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports